module.exports = __webpack_public_path__ + "static/media/snowflakes.779d77fa.svg";